export const classes = {
  wrapper:
    'fixed top-0 left-0 h-screen w-screen z-[1000] place-center overflow-hidden bg-mesh dark:bg-mesh-dark',
};
